import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { ref, provide } from "vue";
import "vant/es/toast/style";
import "vant/es/notify/style";
import "vant/es/dialog/style";
import CustomerService from "@/components/CustomerService.vue";

export default /*#__PURE__*/_defineComponent({
  name: 'App',
  setup(__props) {

const Vheight = document.documentElement.clientHeight + "px";
const customerServiceVisible = ref(false);
const handleShowCustomerService: () => void = () => {
  customerServiceVisible.value = true;
};
const handleCloseCustomerService: () => void = () => {
  customerServiceVisible.value = false;
};
provide("handleShowCustomerService", handleShowCustomerService);
provide("handleCloseCustomerService", handleCloseCustomerService);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view, null, {
      default: _withCtx(({ Component }) => [
        (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
      ]),
      _: 1
    }),
    _createVNode(CustomerService, {
      modelValue: customerServiceVisible.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((customerServiceVisible).value = $event))
    }, null, 8, ["modelValue"])
  ], 64))
}
}

})